import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    Pagination,
    FunctionField,
} from 'react-admin';

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />

const ReferralList = ({ permissions, ...props }) => (
    <List 
        {...props} 
        pagination={<PostPagination />} 
        bulkActionButtons={false}  
        exporter={false} 
        hasCreate={permissions === 'store_owner'}
    >
        <Datagrid rowClick="show">
            <TextField source="referrer_email" label="Referrer Email" />
            <TextField source="referee_email" label="Referee Email" />
            <FunctionField 
                label="Reward" 
                render={record => {
                    if (record.status === 'Complete' && record.Amount) {
                        return `${record.Amount}`;
                    }
                    return '-';
                }}
            />
            <TextField source="status" label="Status" />
            <TextField source="created_at" label="Created Date" />
        </Datagrid>
    </List>
);

export default ReferralList;